import styled from "styled-components";

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  background-color: white;
`;

export const Header = styled.div`
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #e0e0e0;
`;

export const ContentWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
`;

export const CheckIcon = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #1FBC70;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;

  &::after {
    content: '';
    width: 40px;
    height: 70px;
    border: solid white;
    border-width: 0 8px 8px 0;
    transform: rotate(45deg) translateY(-8px);
  }
`;

export const Message = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #000;
  text-align: center;
`;

export const BottomButton = styled.button`
  width: calc(100% - 48px);
  height: 52px;
  border: none;
  font-weight: 600;
  font-size: 16px;
  background-color: #1FBC70;
  border-radius: 12px;
  color: white;
  cursor: pointer;
  margin: 0 24px 24px;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    background-color: #159150;
  }
`;
